import PropTypes from 'prop-types';
import { Navigate, useLocation } from 'react-router-dom';

// Redirects a legacy URL keeping its query string, so deep links (e.g. `?connector=`) still work.
export default function NavigateWithSearch({ to }) {
    const { search } = useLocation();

    return <Navigate to={{ pathname: to, search }} replace />;
}

NavigateWithSearch.propTypes = {
    to: PropTypes.string.isRequired,
};
